import { render, staticRenderFns } from "./AirConditioningStatus.vue?vue&type=template&id=2b1c37d6&scoped=true&"
import script from "./AirConditioningStatus.vue?vue&type=script&lang=js&"
export * from "./AirConditioningStatus.vue?vue&type=script&lang=js&"
import style0 from "./AirConditioningStatus.vue?vue&type=style&index=0&id=2b1c37d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c37d6",
  null
  
)

export default component.exports